// This function divides numbers into grades
// Ex: 1000 => 1 000, 10000 => 10 000, 1000000 => 1 000 000

export const divideNumberByGrade = (value: number | string) => {
  const roundedValue = Math.round((Number(value) + Number.EPSILON) * 100) / 100
  const formattedValue = Number.isInteger(roundedValue)
    ? roundedValue.toFixed(0)
    : roundedValue.toFixed(2)
  return formattedValue.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ")
}
